import { Component,  h, Prop } from '@stencil/core';

@Component({
  tag: 'cms-icon-megaphone',
  shadow: false,
})
export class CmsIconMegaphone {
  /**
   * Define the color used to paint the svg element.
   */
  @Prop() dataFill: string = 'currentColor';
  /**
   * The width of the svg element.
   */
  @Prop() dataWidth: string | number = null;

  /**
   * The height of the svg element.
   */
  @Prop() dataHeight: string | number = null;

  render() {
    return (
      /*@ts-ignore*/
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 40 40"
        focusable="false"
        aria-hidden="true"
        fill-rule="evenodd"
        clip-rule="evenodd"
        width={this.dataWidth}
        height={this.dataHeight}
      >
        <g>
          <path fill="none" d="M24.2,12.6l-19,6l0,1.7l0,1.2l19.1,5.8l0-6.3L24.2,12.6z" />
          <path
            fill="none"
            d="M14.4,25.7l-4.9-1.5l-0.2,0.6c-0.1,0.3,0.1,0.7,0.4,0.8l3.6,1.1c0.3,0.1,0.7-0.1,0.8-0.4L14.4,25.7z"
          />
          <polygon fill="none" points="25.5,11.1 25.5,13.1 25.6,28.9 26.9,28.9 26.8,11.1 	" />
          <polygon fill="none" points="4,17.8 4,17.8 4,17.6 2.7,17.6 2.7,22.7 4,22.7 4,22.5 4,22.5 	" />
          <path
            fill={this.dataFill}
            d="M28.2,28.9L28,11.1c0-0.7-0.6-1.3-1.3-1.3l-1.3,0c-0.7,0-1.3,0.6-1.3,1.3l0,0.2l-19,6.1c-0.1-0.6-0.6-1-1.3-1
		l-1.3,0c-0.3,0-0.7,0.1-0.9,0.4c-0.2,0.2-0.4,0.6-0.4,0.9l0,5.1c0,0.5,0.3,0.9,0.6,1.1c0.2,0.1,0.4,0.2,0.6,0.2l1.3,0
		c0.6,0,1.1-0.5,1.2-1.1l3.1,0.9l-0.2,0.6c-0.3,0.9,0.1,1.8,0.9,2.2c0.1,0.1,0.2,0.1,0.4,0.2l3.6,1.1c1,0.3,2.1-0.3,2.4-1.3l0.2-0.6
		l8.8,2.7l0,0.2c0,0.3,0.1,0.7,0.4,0.9c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.1,0.4,0.2,0.6,0.2l1.3,0c0.3,0,0.7-0.1,0.9-0.4
		C28,29.5,28.2,29.2,28.2,28.9z M2.7,22.7l0-5.1l1.3,0l0,0.2l0,0l0,4.7l0,0l0,0.2L2.7,22.7z M13.4,26.7l-3.6-1.1
		c-0.3-0.1-0.5-0.5-0.4-0.8l0.2-0.6l4.9,1.5l-0.2,0.6C14.1,26.6,13.7,26.8,13.4,26.7z M24.3,27.4L5.3,21.5l0-1.2l0-1.7l19-6l0.1,8.4
		 M25.6,28.9l-0.1-15.8l0-2l1.3,0l0.1,17.8L25.6,28.9z"
          />
          <path
            fill={this.dataFill}
            d="M30,19.4c0,0.2,0.1,0.4,0.3,0.5c0.1,0.1,0.2,0.1,0.3,0.1l7.4,0c0.4,0,0.6-0.3,0.6-0.6c0-0.4-0.3-0.6-0.6-0.6
		l-7.4,0C30.2,18.8,30,19.1,30,19.4z"
          />
          <path
            fill={this.dataFill}
            d="M29.9,15.2c0.1,0.1,0.1,0.2,0.2,0.2c0.2,0.1,0.4,0.1,0.6,0l6.3-3.7c0.3-0.2,0.4-0.6,0.2-0.9
		c-0.2-0.3-0.6-0.4-0.9-0.2l-6.3,3.7C29.8,14.5,29.7,14.9,29.9,15.2z"
          />
          <path
            fill={this.dataFill}
            d="M37.2,27l-6.4-3.6c-0.3-0.2-0.7-0.1-0.9,0.2c-0.2,0.3-0.1,0.7,0.2,0.9l6.4,3.6c0.3,0.2,0.7,0.1,0.9-0.2
		C37.6,27.6,37.5,27.2,37.2,27z"
          />
        </g>
      </svg>
    );
  }
}
